
  document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".faq-card");
    const isDesktop = () => window.innerWidth > 768;

    function closeAll(except = null) {
      cards.forEach(card => {
        if (card !== except) {
          card.classList.remove("active");
        }
      });
    }

    cards.forEach(card => {
      const overlay = card.querySelector(".faq-overlay");

      /* ---------- DESKTOP: HOVER ---------- */
      card.addEventListener("mouseenter", () => {
        if (!isDesktop()) return;
        closeAll(card);
        card.classList.add("active");
      });

      card.addEventListener("mouseleave", () => {
        if (!isDesktop()) return;
        card.classList.remove("active");
      });

      /* ---------- MOBILE: TAP TO TOGGLE ---------- */
      card.addEventListener("click", (e) => {
        if (isDesktop()) return;
        e.stopPropagation();

        const isActive = card.classList.contains("active");
        closeAll(card);
        card.classList.toggle("active", !isActive);
      });

      /* ---------- MOBILE: TAP OVERLAY ---------- */
      overlay.addEventListener("click", (e) => {
        if (isDesktop()) return;
        e.stopPropagation();
        card.classList.toggle("active");
      });
    });

    /* ---------- TAP OUTSIDE (MOBILE ONLY) ---------- */
    document.addEventListener("click", () => {
      if (isDesktop()) return;
      closeAll();
    });
  });

